<template>
    <div v-if="!loading && !error && content.length > 0">
        <h2 v-if="title" class="tagged-news__title tagged-news__title--blue">
            {{title}}
        </h2>
        <div class="tagged-news__container">
            <div class="tagged-news__section">
                <a :href="item.url" class="tagged-news" v-for="(item, index) in sorted.left" :key="`left-${index}`">
                    <div class="tagged-news__content">
                        <h3 class="tagged-news__title">{{item.title}}</h3>
                    </div>
                    <div class="tagged-news__meta"><span>{{item.type}}</span><span>{{item.published}}</span></div>
                </a>
            </div>
            <div class="tagged-news__section">
                <a :href="item.url" class="tagged-news" v-for="(item, index) in sorted.right" :key="`right-${index}`">
                    <div class="tagged-news__content">
                        <h3 class="tagged-news__title">{{item.title}}</h3>
                    </div>
                    <div class="tagged-news__meta"><span>{{item.type}}</span><span>{{item.published}}</span></div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';


export default {
    props: ["title", "tags"],
    data() {
        return {
            error: false,
            loading: true,
            content: [],
            sorted: {
                left: [],
                right: [],
            },
        }
    },
    mounted() {
        this.getRelatedContent();
    },
    watch: {
        content() {
            this.sorted = {
                left: [],
                right: [],
            };
            let left = [];
            let right = [];
            this.content.forEach((item, index) => {
                if (index < 2) {
                    left.push(item);
                } else {
                    if (index < 5) {
                        right.push(item);
                    }
                }
            });
            this.sorted.left = left;
            this.sorted.right = right;
        }
    },  
    methods: {
        getRelatedContent: function () {
            axios.post("/api/related-content/tags", {
                tags: this.tags
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    this.content = response.data.content
                    this.loading = false;
                })
                .catch((err) => {
                    this.error = true;
                    this.loading = false;
                });
        }
    }
}
</script>

